function Weixian() {
  return (
    <div className="weixian">
      <div className="wx" />
      <div className="bio">
        <p>
          Wai Hsuen is the technologist in collaboration with the project. While a software engineer by training, he is an experimenter, a creative and a coder.
          His current focus is in the use of technology in the creative space, physical computing and product innovation.
        </p>
        <p>He got involved in blockchain back in 2017, wrote a whitepaper on a crypto wallet and worked on a few small projects.</p>
        <p>
          After a long hiatus, he is back in the web3 space. The projects he chose to take on must be a collaborative effort with an artist with strong
          credentials, and the work must be creative lead.
        </p>
        <p>Wai Hsuen can turn coffee into code.</p>
      </div>
    </div>
  );
}

export default Weixian;
